<template>
  <div>
    <div class="row" v-if="$route.params.id != 0 && ((loginState.user.id == user.id) || loginState.isAdministrator)">
      <div class="col-md-12">
        <b-button
          variant="primary"
          class="btn btn-primary float-right mb-1"
          v-on:click="changePassword()">
          <i class="icon-lock icons mr-1" />Ändra lösenord
        </b-button>
      </div>
    </div>

    <b-card>
      <div slot="header">
        {{userFullName ? userFullName : "Ny användare"}}
        <div class="card-header-actions">
          <b-spinner v-if="loading" class="mr-1" type="border" small />
        </div>
      </div>
      <b-tabs>

        <!-- Basic information tab -->
        <b-tab active>
          <template slot="title">
            <span :class="{'text-danger': $v.validationGroup_Information.$anyError }">Information</span>
          </template>

          <b-form-group>
            <b-form-checkbox id="active" name="active" v-model="user.isActive" :disabled="!loginState.isAdministrator">
                Aktiv
            </b-form-checkbox>
          </b-form-group>    
          
          <b-form-group>
            <b-form-checkbox v-model="isEmployed" @change="employmentCheck($event)" :disabled="!loginState.isAdministrator || (user.Id != 0)">
                Anställd
            </b-form-checkbox>
          </b-form-group>   

          <b-form-group v-if="$route.params.id == 0 && loginState.isSuperUser">
            <label for="employmentNumber">Företag</label>
            <br />
            <CompaniesDropDown id="employmentNumber"
              :class="{ 'dropdownError': $v.user.companyId.$anyError }" @onCompanySelected="onCompanySelected"/>
              <b-form-invalid-feedback :state="!$v.user.companyId.$anyError">
                Detta fält är obligatoriskt
              </b-form-invalid-feedback> 
          </b-form-group>

          <b-form-group v-if="loginState.isAdministrator || loginState.isSuperUser">
            <label for="employmentNumber">Roll</label>
            <br>
            <b-dropdown :text=selectedRole :disabled="user.id == loginState.user.id" >
                <b-dropdown-item v-for="role in roles" :key="role" v-on:click="onRoleSelected(role)">{{role}}</b-dropdown-item>
            </b-dropdown>
          </b-form-group>    

          <b-form-group v-if="$route.params.id == 0 && loginState.isAdministrator">
              <label for="password">Lösenord</label>
              <input type="password" id="password" name="password"
                  class="form-control col-lg-4 col-md-6 col-sm-9 col-12"
                  v-model.trim="$v.user.changePasswordRequest.newPassword.$model"
                  :class="{ 'is-invalid': $v.user.changePasswordRequest.newPassword.$anyError}"/>
              <b-form-invalid-feedback :state="$v.user.changePasswordRequest.newPassword.$anyError ? true : null">
                Detta fält är obligatoriskt
              </b-form-invalid-feedback> 
          </b-form-group>
          <b-form-group v-if="$route.params.id == 0 && loginState.isAdministrator">
              <label for="confirmedPassword">Bekräfta lösenord</label>
              <input type="password" id="confirmedPassword"
                  class="form-control col-lg-4 col-md-6 col-sm-9 col-12"
                  v-model.trim="$v.user.changePasswordRequest.confirmedPassword.$model"
                  :class="{ 'is-invalid': !$v.user.changePasswordRequest.confirmedPassword.sameAsPassword}"/>
              <b-form-invalid-feedback :state="$v.user.changePasswordRequest.newPassword.$dirty ? $v.user.changePasswordRequest.confirmedPassword.sameAsPassword : null">
                Lösenorden måste vara samma
              </b-form-invalid-feedback> 
          </b-form-group>            
          <b-form-group>
            <label for="name">Förnamn
            </label>
            <b-form-input type="text" id="firstName"
                v-model.trim="$v.user.firstName.$model"
                class="col-lg-4 col-md-6 col-sm-9 col-12"
                :disabled="!loginState.isAdministrator" 
                :class="{ 'is-invalid': $v.user.firstName.$anyError}">
            </b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>             
          </b-form-group>  
          <b-form-group>
            <label for="name">Efternamn</label>
            <b-form-input type="text" id="lastName"
                class="col-lg-4 col-md-6 col-sm-9 col-12"
                v-model.trim="$v.user.lastName.$model"
                :disabled="!loginState.isAdministrator"
                :class="{ 'is-invalid': $v.user.lastName.$anyError}">
            </b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>  
          </b-form-group>  

          <b-form-group>
            <label for="email">E-postadress</label>
            <b-form-input type="email" id="email"
                class="col-lg-4 col-md-6 col-sm-9 col-12"
                v-model.trim="$v.user.email.$model"
                :class="{ 'is-invalid': $v.user.email.$anyError}"
                :disabled="!loginState.isAdministrator"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt och e-postadressen måste vara korrekt
            </b-form-invalid-feedback>  
          </b-form-group>   

          <b-form-group>
              <label for="lightlogotype">Bildfil</label>
              <b-form-file id="lightlogotype" 
              :disabled="!loginState.isAdministrator"
              :state="invalidImage"
              @change="onFileSelected"
              placeholder="Välj en fil för foto..." 
              drop-placeholder="Droppa en fil här..."/>
              <b-form-invalid-feedback :state="invalidImage">Ogiltig bildfil. Filen får inte vara större än 50kB</b-form-invalid-feedback>
              <img v-bind:src="user.image"  v-if="user.image" class="mt-1 mb-2"  />
          </b-form-group>              
        </b-tab>

        <!-- Employee basic information tab -->
        <b-tab v-if="isEmployed" >
            <template slot="title">
              <span :class="{'text-danger': $v.validationGroup_EmployeeInformation.$anyError }">Anställd</span>
            </template>

          <b-form-group>
            <label for="address">Adress</label>
            <b-form-input type="text" id="address"
                class="col-lg-6 col-md-9 col-12"
                :class="{ 'is-invalid': $v.user.address.$anyError}"
                v-model.trim="$v.user.address.$model"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>                  
          </b-form-group>
          <b-form-group>
            <label for="postalCode">Postnummer</label>
            <b-form-input type="text" id="postalCode"
                class="col-lg-2 col-md-3 col-sm-4 col-6"
                :class="{ 'is-invalid': $v.user.postalCode.$anyError}"
                v-model.trim="$v.user.postalCode.$model"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>  
          </b-form-group> 
          <b-form-group>
            <label for="city">Stad</label>
            <b-form-input type="text" id="city"
                class="col-lg-4 col-md-6 col-sm-8 col-10"
                :class="{ 'is-invalid': $v.user.city.$anyError}"
                v-model.trim="$v.user.city.$model"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>  
          </b-form-group>               

          <b-form-group>
            <label for="employmentDate">Anställningsdatum</label>
            <b-form-input type="date" id="employmentDate"
                class="col-lg-2 col-md-4 col-sm-6 col-8"
                v-model.trim=employmentDate
                :class="{ 'is-invalid': $v.user.employmentDate.$anyError}"
                :disabled="!loginState.isAdministrator"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>                
          </b-form-group>              

          <b-form-group>
            <label for="employmentNumber">Anställningsnummer</label>
            <b-form-input type="number" id="employmentNumber"
                class="col-lg-2 col-md-3 col-sm-4 col-5"
                :disabled="!loginState.isAdministrator"
                :class="{ 'is-invalid': $v.user.employmentNumber.$anyError}"
                v-model.number="$v.user.employmentNumber.$model"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>                  
          </b-form-group>
          
          <b-form-group>
            <label for="externalId">Externt id</label>
            <b-form-input type="text" id="externalId"
                class="col-lg-2 col-md-3 col-sm-4 col-5"
                v-model.trim="$v.user.externalId.$model"
                :class="{ 'is-invalid': $v.user.externalId.$anyError}"
                :disabled="!loginState.isAdministrator"></b-form-input>
              <b-form-invalid-feedback>
                Detta fält är obligatoriskt
              </b-form-invalid-feedback> 
          </b-form-group>

          <b-form-group>
            <label for="city">Bankkontonummer</label>
            <div class="input-group">
                <input type="text"
                  :disabled="!loginState.isAdministrator"
                  :class="{ 'is-invalid': $v.user.bankAccountNumber.$anyError}"
                  class="form-control col-lg-4 col-md-6 col-sm-8 col-10" v-model.trim="$v.user.bankAccountNumber.$model">
                  <div v-if="validateBankAccountNumber($v.user.bankAccountNumber.$model)" class="input-group-append">
                      <span class="input-group-text">{{ getBankName($v.user.bankAccountNumber.$model) }}</span>
                  </div>
            </div>
            <b-form-invalid-feedback>
                Detta fält är ett obligatoriskt bankkontonummer
            </b-form-invalid-feedback> 
          </b-form-group>  
        </b-tab>

        <!-- Salary and taxes tab -->
        <b-tab v-if="isEmployed">
          <template slot="title">
              <span :class="{'text-danger': $v.user.salaries.$anyError }">Lön &#38; Skatt</span>
          </template>
          <Salaries :salaries="user.salaries" :v="$v.user.salaries"/>                  
        </b-tab>

        <b-tab v-if="isEmployed">
            <template slot="title">
                <span :class="{'text-danger': $v.user.vacation.$anyError }">Semester &#38; Komp</span>
            </template>

            <b-form-group>
              <label for="givenVacation">Semesterdagar</label>
              <b-form-input type="number" id="givenVacation"
                  class="col-lg-1 col-md-2 col-sm-3 col-4"
                  maxlength="2" 
                  step="1"
                  :disabled="!loginState.isAdministrator"
                  v-model.number="$v.user.vacation.given.$model"
                  :class="{ 'is-invalid': $v.user.vacation.given.$anyError}"></b-form-input>
            <b-form-invalid-feedback>
              Detta fält är obligatoriskt
            </b-form-invalid-feedback>                     
            </b-form-group>
            <b-form-group>
              <label for="advanceVacation">Kvarvarande förskottssemester</label>
              <b-form-input type="number" id="advanceVacation"
                  class="col-lg-1 col-md-2 col-sm-3 col-4"
                  maxlength="2"
                  step="1"
                  :disabled="!loginState.isAdministrator"
                  v-model.number="user.vacation.advance"></b-form-input>
            </b-form-group> 
            <b-form-group>
              <label for="paidVacation">Kvarvarande betald semester</label>
              <b-form-input type="number" id="paidVacation"
                  class="col-lg-1 col-md-2 col-sm-3 col-4"
                  maxlength="2"
                  step="1"
                  :disabled="!loginState.isAdministrator"
                  v-model.number="user.vacation.paid"></b-form-input>
            </b-form-group>
            <b-form-group>
              <label for="savedVacation">Kvarvarande sparad semester</label>
              <b-form-input type="number" id="savedVacation"
                  class="col-lg-1 col-md-2 col-sm-3 col-4"
                  maxlength="2"
                  step="1"
                  :disabled="!loginState.isAdministrator"
                  v-model.number="user.vacation.saved"></b-form-input>
            </b-form-group> 
            <b-form-group>
              <label for="compensatoryTime">Komptid</label>
              <b-form-input type="number" id="compensatoryTime"
                  class="col-lg-1 col-md-2 col-sm-3 col-4"
                  step="0.1"
                  :disabled="!loginState.isAdministrator"
                  v-model.number="user.compensatoryTime"></b-form-input>
            </b-form-group>  
        </b-tab>    
      </b-tabs>

      <button class="btn btn-primary mt-1" v-on:click="saveUser()" :disabled="saving" v-if="loginState.isAdministrator" >
        <b-spinner v-if="saving" class="mr-1" type="border" small />{{saving ? 'Sparar' : 'Spara'}}
      </button>

    </b-card>

    <ChangePasswordDialog ref="changePasswordDialog" :userId="$route.params.id"/>
  </div>
</template>

<script>
import { required, sameAs, email, requiredIf, minValue, between, helpers } from 'vuelidate/lib/validators'
import { userService, employeeService } from "../../shared/services";
import {
  globalStore,
  getBase64,
  bankAccountValidator,
  validators
} from "../../shared/helpers";
import CompaniesDropDown from "../components/CompaniesDropDown";
import Salaries from "./components/Salaries";
import ChangePasswordDialog from "./components/ChangePasswordDialog";


const validateBankAccount = (accountNumber) => bankAccountValidator.validate(accountNumber, true)


export default {
  components: {
    CompaniesDropDown,
    Salaries,
    ChangePasswordDialog
  },
  computed: {
    loginState: function() {
      return globalStore.loginState;
    },
    roles: function() {
      var roleNames = ["Auditor", "User", "Administrator"];
      if (globalStore.loginState.isSuperUser) {
        roleNames.push("SuperUser");
      }
      return roleNames;
    },
    selectedRole() {
      if (!this.user.role) return "Välj roll";
      return this.user.role;
    },
    userFullName() {

      if(!this.user.firstName && !this.user.lastName) return null;

      var newFirstName = this.user.firstName ? this.user.firstName : "";
      var newLastName = this.user.lastName ? this.user.lastName : "";
      return `${newFirstName} ${newLastName}`;
    },
    employmentDate: {
      get: function() {
        return this.$moment(this.$v.user.employmentDate.$model).format("YYYY-MM-DD");
      },
      set: function(date) {
        this.$v.user.employmentDate.$model = this.$moment(date).toDate();
      }
    }
  },
  
  data() {
    return {
      saving: false,
      loading: false,
      isEmployed: false,
      user: {
        isActive: true,
        firstName: null,
        lastName: null,
        companyId: null,
        email: null,
        role: "User",
        address: null,
        postalCode: null,
        city: null,
        compensatoryTime: 0,
        employmentNumber: null,
        employmentDate: null,
        externalId: null,
        bankAccountNumber: null,
        vacation: {
          given: null,
          saved: 0,
          advance: 0,
          paid: 0
        },
        salaries: [
          {
            id: 0,
            fromDate: this.$moment("1753-01-01").toDate(),
            toDate: this.$moment("9999-12-01").toDate(),
            haveVariableSalaryByOccupancy: false,
            basicSalary: null,
            taxTable: null,
            variableSalary: null,
            variableSalaryCutOff: null
          }
        ],
        changePasswordRequest: {
          newPassword: null,
          confirmedPassword: null
        }
      },

      invalidImage: null,
      variableSalaryByOccupancy: false,
      showChangePassword: false,
    };
  },

  validations() {
    var userValidation = {
        user: {
            firstName: {
              required
            },
            lastName: {
              required
            },
            companyId: {
              required
            },
            email: {
              required,
              email
            }
        },
        validationGroup_Information: ['user.firstName', 'user.lastName', 'user.companyId'],
    };
    
    var employeeValidation = {
      user: {
            firstName: {
              required
            },
            lastName: {
              required
            },
            companyId: {
              required
            },
            email: {
              required,
              email
            },
            address: {
              required,
            },
            postalCode: {
              required,
            },
            city: {
              required
            },
            bankAccountNumber: {
              required: requiredIf(function(form) {
                return this.isEmployed;
              }),
              validateBankAccount
            },
            employmentDate: {
              required: requiredIf(function(form) {
                return this.isEmployed;
              })
            },
            employmentNumber: {
              required: requiredIf(function(form) {
                return this.isEmployed;
              })
            },
            externalId: {
              required: requiredIf(function(form) {
                return this.isEmployed;
              })
            },  
            
            salaries: {
              $each: {
                id: {},
                basicSalary: {
                  required,
                  minValue: minValue(0)
                },
                taxTable: {
                  required,
                  between: between(29, 40) 
                },                    
                fromDate: {
                  required,
                },
                toDate: {
                  required,
                },
                haveVariableSalaryByOccupancy: {},
                variableSalary: {
                  required: requiredIf((salary) => {return salary.haveVariableSalaryByOccupancy}),
                  minValue: minValue(0)                        
                },
                variableSalaryCutOff: {
                  required: requiredIf((salary) => {return salary.haveVariableSalaryByOccupancy}),
                  minValue: between(0, 1)   
                }
              }
            },
            vacation: {
              given: {
                required
              }
            },
          },
          validationGroup_Information: ['user.firstName', 
          'user.lastName', 
          'user.companyId'],
          validationGroup_EmployeeInformation: ['user.employmentNumber', 
          'user.externalId',
          'user.email', 
          'user.address',
          'user.postalCode', 
          'user.city', 'user.bankAccountNumber']
      };

      var setPasswordValidator = {
        newPassword: {
          required
        },
        confirmedPassword: {
          sameAsPassword: sameAs('newPassword')
        }
      };

      var validator = userValidation;

      if(this.isEmployed)  {
        validator = employeeValidation;
      }
      
      if (this.$route.params.id == 0) {
          validator.user.changePasswordRequest = setPasswordValidator;
          validator.validationGroup_Information = ['user.firstName', 'user.lastName', 'user.companyId', 'user.changePasswordRequest.confirmedPassword.sameAsPassword'];
      }

      return validator;
  },

  mounted() {
    if(!this.loginState.isSuperUser) this.user.companyId = this.loginState.user.companyId;
    if (this.$route.params.id == 0) return;
    this.isEmployed = (this.$route.query.employee === 'true');
    var promise = this.isEmployed ? employeeService.getById(this.$route.params.id) : userService.getById(this.$route.params.id);

    this.loading = true;
    promise.then(p => {
        this.loading = false;
        this.user = p;
        this.loading = false;
      })
      .catch(p => {
        this.loading = false;
        console.log(this.user)

        this.ShowToast(
          "Fel",
          "Ett okänt fel uppstod då användaren skulle hämtas",
          "danger"
        );
      });
  },
  methods: {
    employmentCheck(event) {
      this.employed = event;
    },
    getBankName(accountNumber) {
      return bankAccountValidator.getBankName(accountNumber);
    },
    validateBankAccountNumber(accountNumber) {
      return bankAccountValidator.validate(accountNumber);
    },
    onCompanySelected(company) {
      this.user.companyId = company.id;
      this.$v.user.companyId.$touch();
    },
    onRoleSelected(role) {
      this.user.role = role;
    },
    onFileSelected(event) {
      this.invalidImage = null;
      if (event.target.files[0].size > 50000) {
        this.invalidImage = false;
        return;
      }
      getBase64(event.target.files[0]).then(p => {
        this.user.image = p;
      });
    },
    saveUser() {
        var promise = null;
        this.$v.user.$touch();

        if(this.isEmployed) {      
          if(this.$v.user.$anyError) return;
          promise = employeeService.save(this.user);
        } 
        else {
          if(this.$v.validationGroup_Information.$anyError) return;
          promise = userService.saveUser(this.user);
        }
          
        this.saving = true;
        promise.then(() => {
              this.saving = false;
              this.ShowToast(
                "Sparad",
                "Användarinformationen sparades",
                "success"
              );

              globalStore.users = null;

              if (this.$route.params.id == 0) {
                this.$router.push({
                  path: "/administration/users?companyId=" + this.user.companyId
                });
              }
            }).catch(() => {
              this.ShowToast(
                "Fel",
                "Ett okänt fel uppstod då användardata skulle sparas",
                "danger"
              );
              this.saving = false;
            });

    },
    changePassword() {
      this.$refs.changePasswordDialog.show();
    }
  },
};
</script>

<style>

.dropdownError button {
  border: 1px solid #f86c6b;
}

.dropdownOk button {
  border: 1px solid #4dbd74;;
}


</style>
